import React from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { UseFormReturn } from 'react-hook-form';
import getImagePath from '../../../../../../../CommonUtils/getImagePath';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../../../../../CommonComponents/OPL/Button/Button';
import { LOGO_CONTAINER_HEIGHT } from '../../FirmLogo.meta';

interface Props {
  fieldName: string;
  firmLogoFilename: string;
  formBag: UseFormReturn;
  dropZoneOptions: DropzoneOptions;
}

export const LogoPreview: React.FC<Props> = ({
  fieldName,
  firmLogoFilename,
  dropZoneOptions,
  formBag,
}) => {
  const { open, getInputProps } = useDropzone(dropZoneOptions);

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height={LOGO_CONTAINER_HEIGHT}
    >
      <Box
        as="img"
        width="auto"
        maxWidth={340}
        maxHeight={175}
        src={getImagePath(firmLogoFilename, true)}
        alt="Firm logo"
      />

      <input {...getInputProps()} />

      <Box mt="16">
        <Button
          variant="secondary"
          onClick={() => formBag.setValue(fieldName, null, { shouldDirty: true })}
          mr="8"
        >
          Remove Your Logo
        </Button>

        <Button onClick={open}>Upload Your Logo</Button>
      </Box>
    </Box>
  );
};
